import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import { specialOfferPath, SpecialOfferUrlQueryParams } from "./urls";
import SpecialOfferComponent from "./views/SpecialOffer";

const specialOffer: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: SpecialOfferUrlQueryParams = qs;
  return <SpecialOfferComponent params={params} />;
};
export const SpecialOfferSection: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.specialOffer)} />
      <Switch>
        <Route exact path={specialOfferPath} component={specialOffer} />
      </Switch>
    </>
  );
};
export default SpecialOfferSection;
